import React from 'react';

class ProgressRing extends React.Component {
    constructor(props) {
      super(props);
  
      const { radius, stroke } = this.props;
  
      this.normalizedRadius = radius - stroke * 2;
      this.circumference = this.normalizedRadius * 2 * Math.PI;
    }

    render() {
        const { radius, stroke, progress } = this.props;
        const strokeDashoffset = this.circumference - progress / 100 * this.circumference;
        
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        const yPos = isIE11 ? '64%' : '54%'
        return (
          <svg
            height={radius * 2}
            width={radius * 2}
            >
            <circle
              stroke="#dee2e4"
              fill="transparent"
              strokeWidth={ stroke }
              r={ this.normalizedRadius }
              cx={ radius }
              cy={ radius }
            />
            <circle
              stroke="#f29f5c"
              fill="transparent"
              strokeWidth={ stroke }
              strokeDasharray={ this.circumference + ' ' + this.circumference }
              style={ { strokeDashoffset } }
              r={ this.normalizedRadius }
              cx={ radius }
              cy={ radius }
              transform={`rotate(270 ${radius} ${radius})`}
              />
              <text x="50%" y={yPos} dominantBaseline="middle" textAnchor="middle" fontFamily="Roboto" fontSize="30px" color="#5b6d74">
                <tspan>{Math.floor(progress)}</tspan>
                <tspan dy="-8" fontSize="12px">%</tspan>
              </text>
          </svg>
        );
      }    
  }

  ProgressRing.defaultProps = {
      stroke:4,
      radius: 40
  }
  
export default ProgressRing;


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DebriefDashboard/components/ProgressRing/index.jsx